import React, { ChangeEvent, useEffect, useState } from 'react';
import InputBase, { InputBaseProps } from '../InputBase/InputBase';
import { isNil } from '../../../../utils/objectUtils';
import { GreaterThanValidator } from '../../../../validators/greaterThan.validator';

export type NumericInputProps = {
    numDecimals?: number;
    greaterThan?: number;
} & InputBaseProps;

const NumericInput = ({
    numDecimals = 0,
    greaterThan = undefined,
    ...props
}: NumericInputProps) => {
    const [previousInput, setPreviousInput] = useState('');

    useEffect(() => {
        if (props.formMethods) {
            //for now, assume this is greater than OR equal to
            if (greaterThan) {
                props.formMethods.addValidator(
                    props.id,
                    props.label.toString(),
                    GreaterThanValidator(greaterThan)
                );
            }
        }
    }, []);

    const onValueChanged = (
        event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        const currentValue: any = event.target.value;
        let isValidNumber: boolean;

        if (isNil(currentValue) || currentValue === '-') {
            isValidNumber = true;
        } else if (numDecimals > 0) {
            isValidNumber = RegExp(
                `^$|^-?\\d+(?:[\\.\\,]\\d{0,${numDecimals}})?$`,
                'g'
            ).test(currentValue);
        } else {
            //not specifying the number of decimals will be treated as zero decimals
            isValidNumber = new RegExp(`^-?\\d+$`, 'g').test(currentValue);
        }

        if (isValidNumber) {
            setPreviousInput(currentValue);
        } else {
            event.target.value = previousInput;
        }

        props.onChange && props.onChange(event);
    };

    return <InputBase {...props} onChange={(event) => onValueChanged(event)} />;
};

export default NumericInput;
